import { getAdminDashboardData, getDashboardData } from "./DashboardActions";
import { createSlice } from "@reduxjs/toolkit";

interface DashboardState {
  data: any | null;
  loading: boolean;
  error: any | null;

  adminData: any | null;
  adminLoading: boolean;
  adminError: any | null;
}

const initialState: DashboardState = {
  data: null,
  loading: false,
  error: null,

  adminData: null,
  adminLoading: false,
  adminError: null,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDashboardData.pending, (state) => {
      state.loading = true;
      state.error = null;
      state.data = null;
    });
    builder.addCase(getDashboardData.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getDashboardData.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getAdminDashboardData.pending, (state) => {
      state.adminLoading = true;
      state.adminError = null;
      state.adminData = null;
    });
    builder.addCase(getAdminDashboardData.fulfilled, (state, action) => {
      state.adminData = action.payload;
      state.adminLoading = false;
      state.adminError = null;
    });
    builder.addCase(getAdminDashboardData.rejected, (state, action) => {
      state.adminError = action.payload;
      state.adminLoading = false;
      state.adminError = action.payload;
    });
  },
});

const dashboardReducer = dashboardSlice.reducer;

export default dashboardReducer;
